export enum IncentiveAmountType {
  Incremental = 0,
  Override = 1,
  //EarnedOrAmount = 2,
  //OverrideIfPositive = 3 //built to allow separation of LH and Spot for 6th day but if both trigger, then there will be too many negatives
}

export const IncentiveAmountTypeMapping = {
  [IncentiveAmountType.Incremental]: 'Incremental',
  [IncentiveAmountType.Override]: 'Override / Replace'
  //[IncentiveAmountType.EarnedOr]: 'Earned or Amount',
  //[IncentiveAmountType.OverrideIfPositive]: 'Override if Positive'
};
